import React, {Component} from 'react'
import ReactSVG from 'react-svg'

import ColumnLinks from './../../Components/ColumnLinks'
import HeaderLink from './../../Components/HeaderLink'
import Text from './../../Components/Text'

import Values from './../../Components/Values'

import Swiper from 'react-id-swiper'

import './banner.css'


class Banner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			gallerySwiper: null,
			textSwiper: null
		};

		this.galleryRef = this.galleryRef.bind(this);
		this.textRef = this.textRef.bind(this);
	}

	componentWillUpdate(nextProps, nextState) {
		if (nextState.gallerySwiper && nextState.textSwiper) {
			const { gallerySwiper, textSwiper } = nextState

			gallerySwiper.controller.control = textSwiper;
			textSwiper.controller.control = gallerySwiper;
		}
	}

	galleryRef(ref) {
		if(ref) this.setState({ gallerySwiper: ref.swiper })
	}

	textRef(ref) {
		if(ref) this.setState({ textSwiper: ref.swiper })
	}

	sliderBg(){
		return (
			<div>
				<Swiper ref={this.galleryRef}>
					{
						this.props && this.props.slider ? this.props.slider.map((slide)=>(
							<div className="slide" key={slide.id} style={{"backgroundImage": `url('${slide.imgUrl}')`, "backgroundSize": "cover", "backgroundPosition": "center"}}>
							</div>
						)) : ''
					}
				</Swiper>
			</div>
		)
	}

	sliderCentered(){

        const gallerySwiperParams = {
			pagination: {
				el: '.swiper-pagination.swiper-pagination-white',
				type: 'bullets',
				clickable: true
			}
        };
		return (
			<div className="content_slider">
				{this.props && this.props.slider.length>1 ? (
					<Swiper {...gallerySwiperParams}>
						{
							this.props.slider.map((slide)=>(
								<div className="slide" key={slide.id} style={{"backgroundImage": `url('${slide.imgUrl}')`, "backgroundSize": "cover", "backgroundPosition": "center"}}>
									{this.props.columnLinks ===null  && slide.cols === undefined  ? (
										<div className="row">
											{
												slide.title_icon && slide.title_icon ? <div className="box__title"><i><ReactSVG path={slide.title_icon} /></i><h2 dangerouslySetInnerHTML={{__html: slide.title}} /></div> : <h2 dangerouslySetInnerHTML={{__html: slide.title}} />
											}
											<Text text={slide.text} />
											{
												slide.links && slide.links.map((link, id)=>(
													<HeaderLink url={link.url} text={link.caption} target={link.target} key={id} className="btn" />		
												))	
											}
										</div>
										): (
											<div className="row row--cols-bg">
												{
													slide.cols.map((col,_i)=>(
														<div className="col" key={_i} style={{"backgroundImage": `url('${col.imgUrl}')`, "backgroundSize": "cover", "backgroundPosition": "center"}}>
															<div>
																<div>
																	<Text text={col.text} />
																	{
																		col.links && col.links.map((link, id)=>(
																			<HeaderLink url={link.url} text={link.caption} target={link.target} key={id} className="btn btn--x-small" />		
																		))	
																	}
																</div>
															</div>
														</div>
													))
												}
											</div>
										)
									}
									
								</div>
							))
						}
					</Swiper>
				): (<div className="container_banner">
						
					{
						this.props.slider.map((slide)=>(
							<div className="slide" key={slide.id} style={{"backgroundImage": `url('${slide.imgUrl}')`, "backgroundSize": "cover", "backgroundPosition": "center"}}>
								{this.props.columnLinks ===null && slide.cols === undefined ? (
									<div className="row">
										{
											slide.title_icon && slide.title_icon ? <div className="box__title"><i><ReactSVG path={slide.title_icon} /></i><h2 dangerouslySetInnerHTML={{__html: slide.title}} /></div> : <h2 dangerouslySetInnerHTML={{__html: slide.title}} />
										}
										<Text text={slide.text} />
									</div>
									): (
										<div className="row row--cols-bg">
											{
												slide.cols.map((col,_i)=>(
													<div className="col" key={_i} style={{"backgroundImage": `url('${col.imgUrl}')`, "backgroundSize": "cover", "backgroundPosition": "center"}}>
														<div>
															<div>
																<Text text={col.text} />
																{
																	col.links && col.links.map((link, id)=>(
																		<HeaderLink url={link.url} text={link.caption} target={link.target} key={id} className="btn btn--x-small" />		
																	))	
																}
															</div>
														</div>
													</div>
												))
											}
										</div>
									)
								}
								<div className="arrow__down"></div>
							</div>
						))
					}
				</div>)}
				
			</div>
		)
	}


	slider(){

        const gallerySwiperParams = {
			pagination: {
				el: '.swiper-pagination.swiper-pagination-white',
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: '.swiper-button-next.swiper-button-white',
				prevEl: '.swiper-button-prev.swiper-button-white'
			}
        };
		return(
			<div>
				<Swiper {...gallerySwiperParams} ref={this.textRef} >
					{
						this.props && this.props.slider ? this.props.slider.map((slide)=>(
							<div key={slide.id} className="slide" >
								<div className="col col--3">
								</div>
								<div className="col col--7">
									<div>
										<h2 dangerouslySetInnerHTML={{__html: slide.title}} />
										<Text text={slide.text} />
										{
											slide.links && slide.links.map((link,id)=>(
												<HeaderLink url={link.url} text={link.caption} target={link.target} key={id}  className="btn" />		
											))	
										}
									</div>
								</div>
							</div>
						)) : ''
					}
				</Swiper>
			</div>
		)
	}

	columnLinks(){

		return(
			<div className="row">
				<div className="col col--3">
					<ColumnLinks columnLinks={this.props.columnLinks} title={this.props.title} text={this.props.text} />
				</div>
				<div className="col col--10">
					{ this.slider() }
				</div>
			</div>
		)
	}

	render(){

		const {columnLinks,contacts,values} = this.props
		//(values ? 'banner--with-values' : '')
		return(
			<div className={columnLinks ? 'banner--withservices' : (values ? 'banner--with-values' : '')}>
				<div className="slider_bg">
					{
						columnLinks !== null ? this.sliderBg() : this.sliderCentered()
					}
					{
						contacts !== null ? (<div className="contacts">
							{

								contacts.map((link,id)=>( 
									<HeaderLink url={link.link.url} text={link.link.caption} target={link.link.target} icon={link.icon} key={id} />		
								))
							}
						</div>):''
					}
				</div>
				{
					columnLinks !==null ? this.columnLinks() : ''
				}
				{
					values && values !== null ? <Values values={values} /> : ''
				}
			</div>
		)
	}
}

export default Banner


// WEBPACK FOOTER //
// ./src/Containers/Banner/index.js